import { Inject, Injectable } from '@angular/core';
import { IIPLookupServiceToken, IIPLookupService } from 'src/app/interfaces/ip-lookup-service.interface';

@Injectable()
export class IpLookUpManagerService implements IIPLookupService {
  constructor(@Inject(IIPLookupServiceToken) private ipServices: IIPLookupService[]) {}

  async getIp(): Promise<string> {
    for (const service of this.ipServices) {
      try {
        const ip = await service.getIp();
        if (ip) {
          return Promise.resolve(ip);
        }
      } catch (error) {
        Promise.reject(error);
      }
    }

    return Promise.reject('All IP lookup services failed');
  }
}
